import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConsultantProfileContext } from "@/components/User";
import { fetchMostRecentJobRequests } from "@/data/job-requests";
import { useFetcher } from "@/hooks/http";
import { JobsWidget } from "@/views/JobRequests/JobsWidget/JobsWidget";

export const RecentlyViewedWidget: FC = () => {
  const ConsultantProfile = useContext(ConsultantProfileContext);

  const { t } = useTranslation("session");

  const fetcher = useFetcher(fetchMostRecentJobRequests, { companyId: ConsultantProfile.currentCompanyId }, [
    ConsultantProfile.currentCompanyId,
  ]);

  if (!fetcher.payload || fetcher.payload.length === 0) {
    return null;
  }

  return <JobsWidget header={t("DASHBOARD.RECENTLY_VIEWED_WIDGET.HEADER")} jobs={fetcher.payload} />;
};
